import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
export function useDoOnce(cb) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    done = _React$useState2[0],
    setDone = _React$useState2[1];
  return React.useCallback(function () {
    if (!done) {
      setDone(true);
      return cb.apply(void 0, arguments);
    }
  }, [cb, done]);
}

/** Оборачивает пользовательский коллбэк в useDoOnce обертку, если требуется */
export var useGetCallback = function useGetCallback(cb, triggerOnce) {
  var onceCb = useDoOnce(cb);
  return React.useMemo(function () {
    return triggerOnce ? onceCb : cb;
  }, [cb, onceCb, triggerOnce]);
};